import React from 'react';
import atoms from 'ctsutheme/components/atoms';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  FasArrowUp,
  FasArrowDown,
  FasArrowRight,
  FasArrowLeft,
  FarWindowMaximize,
  FasColumns
} from 'assets/icons';
import { TE } from 'appconstants';

const { Typography, IconButton } = atoms;

const styles = theme => ({
  card: {
    minHeight: '85vh',
    margin: '5px'
  },
  cardActions: {
    paddingRight: 8,
    paddingTop: 8,
    color: theme.palette.primary
  }
});

const DirectionArrow = ({
  color,
  onArrowClick,
  className,
  iconName,
  dataDirection
}) => (
  <Typography link icon inline>
    <IconButton
      aria-label="Split Sections"
      color={color}
      data-id={`${TE.ID}split_section${TE.BTN}`}
      data-direction={dataDirection}
      onClick={(event) => onArrowClick(event.currentTarget.dataset.direction)}
    >
      {iconName}
    </IconButton>
  </Typography>
);

const ProtActions = ({
  classes,
  splitScreen,
  selectedGridDirection,
  onArrowClick,
  toggleSplitScreen
}) => {
  const getArrowIconColor = grdDir => (grdDir === selectedGridDirection
    ? 'primary'
    : 'secondary');
  return (
    <Grid
      container
      className={classes.cardActions}
      direction="row"
      justify="flex-end"
      alignItems="center"
    >

        Pin to
      <DirectionArrow
        color={!splitScreen ? 'disabled' : getArrowIconColor('Right')}
        onArrowClick={onArrowClick}
        data-id={`${TE.ID}right_view${TE.BTN}`}
        iconName={<FasArrowLeft />}
        dataDirection="Right"
      />

      <DirectionArrow
        color={!splitScreen ? 'disabled' : getArrowIconColor('Bottom')}
        onArrowClick={onArrowClick}
        iconName={<FasArrowUp />}
        data-id={`${TE.ID}bottom_view${TE.BTN}`}
        dataDirection="Bottom"
      />
      <DirectionArrow
        color={!splitScreen ? 'disabled' : getArrowIconColor('Top')}
        onArrowClick={onArrowClick}
        data-id={`${TE.ID}top_view${TE.BTN}`}
        iconName={<FasArrowDown />}
        dataDirection="Top"
      />
      <DirectionArrow
        color={!splitScreen ? 'disabled' : getArrowIconColor('Left')}
        onArrowClick={onArrowClick}
        data-id={`${TE.ID}left_view${TE.BTN}`}
        iconName={<FasArrowRight />}
        dataDirection="Left"
      />
      |
      {splitScreen ? (
        <>
          <Typography link icon inline>
            <IconButton
              aria-label="Maximize Sections"
              color="primary"
              data-id={`${TE.ID}maximimize_view${TE.BTN}`}
              onClick={toggleSplitScreen}
            >
              <FarWindowMaximize />
            </IconButton>
          </Typography>
          Single Screen
        </>
      ) : (
        <>
          <Typography link icon inline>
            <IconButton
              aria-label="Minimize Sections"
              color="secondary"
              onClick={toggleSplitScreen}
              data-id={`${TE.ID}minimize_view${TE.BTN}`}
            >
              <FasColumns />
            </IconButton>
          </Typography>
          Split Screen
        </>
      )}
    </Grid>
  );
};

export const ProtocolActions = withStyles(styles)(ProtActions);
